import { render, staticRenderFns } from "./ChannelsEdit.vue?vue&type=template&id=06091f5a&"
import script from "./ChannelsEdit.vue?vue&type=script&lang=ts&"
export * from "./ChannelsEdit.vue?vue&type=script&lang=ts&"
import style0 from "./ChannelsEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ChannelsEdit.vue"
export default component.exports